export const state = {
    channels: [],
}

export const getters = {}

export const mutations = {
    SET_CHANNELS(state, channels) {
        state.channels = channels
    },
}

export const actions = {}
